import { render, staticRenderFns } from "./addCoursedetail.vue?vue&type=template&id=106bec90&scoped=true&"
import script from "./addCoursedetail.vue?vue&type=script&lang=js&"
export * from "./addCoursedetail.vue?vue&type=script&lang=js&"
import style0 from "./addCoursedetail.vue?vue&type=style&index=0&id=106bec90&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106bec90",
  null
  
)

export default component.exports